import ImageEl from "@/components/Image.vue"
export default {
    components: { ImageEl }
}